export const config = {
    // apiUrl: "https://cup-test.invisiblefarm.it"
    // apiUrl: "https://cupvet.ats-insubria.it"
    // apiUrl: "http://localhost:3039"
      apiUrl: ""
};
